<template>
  <div>
  
    <div>
      <div>
      </div>
      <div class="w-full flex justify-between items-center">
        <div>
          <!-- {{validateTodayDate()}} -->
          <h3><strong>{{ eachEventInfo.title }}</strong></h3>
        </div>
        <div class="flex justify-end" vs-align="flex-end">
          <vs-button
            radius
            v-if="validateTodayDate() <= 0"
            @click="editingEvent(eachEventInfo.id)"
            icon="edit"
            color="primary"
            class="mr-2"
            vs-type="flex"
            style="margin-right: 0"
          />
          <vs-button
            radius
            icon="delete"
            color="danger"
            vs-type="flex"
            style="margin-right: 0"
            @click="deleteEvent(eachEventInfo.id)"
          />
        </div>
        <!-- time and date -->
      </div>
      <strong>Description</strong>
      <p
        v-html="eachEventInfo.extendedProps.description"
        v-if="eachEventInfo.extendedProps.description"
      ></p>
    </div>

    <!-- teacher details -->
    <div class="flex flex-wrap my-4">
      <div class="teacher-info">
        <div>
          <feather-icon icon="MapPinIcon" />
        </div>
        <div class="ml-2">
          <strong>Location</strong>
          <p v-if="eachEventInfo.extendedProps.location">
            {{ eachEventInfo.extendedProps.location }}
          </p>
        </div>
      </div>
      <!-- <div class="teacher-info">
        <div>
          <feather-icon icon="TagIcon" />
        </div>
      </div> -->
      <div class="teacher-info">
        <div>
          <feather-icon icon="CalendarIcon" />
        </div>
        <div class="ml-2">
          <strong>Start Timing</strong>
          <p>{{ eachEventInfo.extendedProps.startTiming }}</p>
        </div>
      </div>
      <div class="teacher-info">
        <div>
          <feather-icon icon="CalendarIcon" />
        </div>
        <div class="ml-2">
          <strong>End Timing</strong>
          <p>{{ eachEventInfo.extendedProps.endTiming }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'

import { DeleteScheduleApi } from '@/api/schedulerApi.js'

export default {
  props: {
    eachEventInfo: {
      type: Object,
      required: true
    }
  },
  methods: {
    validateTodayDate () {
      const today = moment(new Date())
      const selectedDate = moment(this.eachEventInfo.start)
      const differenceDate = today.diff(selectedDate, 'days')
      return differenceDate
    },
    editingEvent (id) {
      this.$emit('editingEvent', id)
      console.log(id)
    },
    async deleteEvent (id) {
      console.log(id)
      try {
        await DeleteScheduleApi(id)
        this.showSuccessMessage(
          'success',
          'Event Deleted Successfully',
          'success'
        )
        this.$emit('eventEmitDeleted', id)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>